module.exports = __webpack_public_path__ + "static/media/jan_polish.6e26ce2c.mp3";